import {
  Card,
  Divider,
  Form,
  Table,
  Button,
  Radio,
  Space,
  Select,
  Row,
  Col,
  Input,
  message,
} from "antd";
import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import Templates from "../../NewProperty/componentss/LeaseSettings/Templates";
import { collection, doc, getDocs, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { useEffect } from "react";

const LeaseSetting = ({ data, dataId, isUpdate, companyName }) => {
  const [form] = Form.useForm();

  const [isEditActive, setIsEditActive] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [template, setTemplate] = useState(data?.leaseGenerationDefaultMethod);
  const [amount, setAmount] = useState(
    data?.defaultRenewalSettings?.changeRentBy
  );

  const handleTemplate = (e) => {
    setTemplate(e.target.value);
  };
  const handleDollarOrPerc = (e) => {
    setAmount(e.target.value);
  };

  const changeByIcon = data?.chargeRentBy === "dollar" ? "$" : "%";

  const columns = [
    {
      title: "Term",
      dataIndex: "term",
      render: (_, record) => <p>{record.term}</p>,
    },
    {
      title: `Change by ${changeByIcon}`,
      dataIndex: "changeby",
      render: (_, record) => <p>{record.changeByAmount}</p>,
    },
    {
      title: "Additional Fee",
      dataIndex: "additionalFee",
      render: (_, record) => <p>{record.additionalFee}</p>,
    },
  ];

  const [dLT, setDLT] = useState([{ id: uuidv4(), template: "" }]);
  const [dRT, setDRT] = useState([{ id: uuidv4(), template: "" }]);
  const [dMRT, setDMRT] = useState([{ id: uuidv4(), template: "" }]);

  useEffect(() => {
    if (companyName) {
      const fetchProperties = async () => {
        try {
          const PropertyRef = collection(
            db,
            "companies",
            companyName,
            "properties"
          );
          const snapshot = await getDocs(PropertyRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          const filteredProperty = fetchedData.find(
            (item) => item.id === dataId
          );
          setDLT(
            filteredProperty?.leaseSettings?.pdfFormTemplates
              ?.defaultLeaseTemplates?.length >= 1
              ? filteredProperty?.leaseSettings?.pdfFormTemplates
                  ?.defaultLeaseTemplates
              : [
                  {
                    id: uuidv4(),
                    template: "",
                  },
                ]
          );
          setDRT(
            filteredProperty?.leaseSettings?.pdfFormTemplates
              ?.defaultRenewalTemplates?.length >= 1
              ? filteredProperty?.leaseSettings?.pdfFormTemplates
                  ?.defaultRenewalTemplates
              : [
                  {
                    id: uuidv4(),
                    template: "",
                  },
                ]
          );
          setDMRT(
            filteredProperty?.leaseSettings?.pdfFormTemplates
              ?.defaultRenewalMTMTemplates?.length >= 1
              ? filteredProperty?.leaseSettings?.pdfFormTemplates
                  ?.defaultRenewalMTMTemplates
              : [
                  {
                    id: uuidv4(),
                    template: "",
                  },
                ]
          );
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchProperties();
    }
  }, [companyName, isEditActive]);

  const initialValues = {
    leaseGenerationDefaultMethod: data?.leaseGenerationDefaultMethod,

    addendaTemplatesL:
      data?.sayEagleTemplates?.defaultLeaseTemplates?.addendaTemplates,
    leaseAttachmentsL:
      data?.sayEagleTemplates?.defaultLeaseTemplates?.leaseAttachments,
    leaseTemplateL:
      data?.sayEagleTemplates?.defaultLeaseTemplates?.leaseTemplate,

    renewalLeaseTemplateR:
      data?.sayEagleTemplates?.defaultRenewalTemplates?.renewalTemplate,
    renewalAddendaTemplateR:
      data?.sayEagleTemplates?.defaultRenewalTemplates?.addendaTemplates,
    renewalLeaseAttachmentR:
      data?.sayEagleTemplates?.defaultRenewalTemplates?.renewalAttachments,
    monthToMonthLeaseTemplateRM:
      data?.sayEagleTemplates?.defaultRenewalMTMTemplates?.mTMRenewalTemplate,
    monthToMonthAddendaTemplateRM:
      data?.sayEagleTemplates?.defaultRenewalMTMTemplates?.addendaTemplates,
    monthToMonthLeaseAttachmentRM:
      data?.sayEagleTemplates?.defaultRenewalMTMTemplates
        ?.mTmRenewalAttachments,

    template: data?.defaultRenewalSettings?.template,

    changeRentBy: data?.defaultRenewalSettings?.changeRentBy,
  };

  const onFinish = async (values) => {
    console.log("Success:", values);
    isUpdate(true);
    setIsWaiting(true);

    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertyDocRef = doc(companyDocRef, "properties", dataId);
      await updateDoc(propertyDocRef, {
        "leaseSettings.leaseGenerationDefaultMethod":
          values.leaseGenerationDefaultMethod || "",
        "leaseSettings.sayEagleTemplates.defaultLeaseTemplates": {
          leaseTemplate: values.leaseTemplateL || "",
          addendaTemplates: values.addendaTemplatesL || [],
          leaseAttachments: values.leaseAttachmentsL || [],
        },
        "leaseSettings.sayEagleTemplates.defaultRenewalTemplates": {
          renewalTemplate: values.renewalLeaseTemplateR || "",
          addendaTemplates: values.renewalAddendaTemplateR || [],
          renewalAttachments: values.renewalLeaseAttachmentR || [],
        },
        "leaseSettings.sayEagleTemplates.defaultRenewalMTMTemplates": {
          mTMRenewalTemplate: values.monthToMonthLeaseTemplateRM || "",
          addendaTemplates: values.monthToMonthAddendaTemplateRM || [],
          mTmRenewalAttachments: values.monthToMonthLeaseAttachmentRM || [],
        },
        "leaseSettings.pdfFormTemplates": {
          defaultLeaseTemplates: dLT,
          defaultRenewalTemplates: dRT,
          defaultRenewalMTMTemplates: dMRT,
        },
        "leaseSettings.defaultRenewalSettings": {
          changeRentBy: values.changeRentBy || "",
          template: values.template || "",
          renewalOptions: accounts,
        },
      });
      message.success("Lease  Data Updated Successfully..", 3);

      setTimeout(() => {
        setIsEditActive(false);
        isUpdate(true);
        setIsWaiting(false);
      }, 3000);
    } catch (error) {
      console.error("not updated:", error);
      message.error("Failed to update Lease  data", 3);
      setIsWaiting(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setIsWaiting(false);
  };

  const [accounts, setAccounts] = useState([
    { id: uuidv4(), term: "", changeByAmount: "0.00", additionalFee: "0.00" },
  ]);

  useEffect(() => {
    if (companyName) {
      const fetchTenants = async () => {
        try {
          const tenantRef = collection(
            db,
            "companies",
            companyName,
            "properties"
          );
          const snapshot = await getDocs(tenantRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          const filteredTenant = fetchedData.find((item) => item.id === dataId);
          setAccounts(
            filteredTenant?.leaseSettings?.defaultRenewalSettings
              ?.renewalOptions?.length >= 1
              ? filteredTenant?.leaseSettings?.defaultRenewalSettings
                  ?.renewalOptions
              : [
                  {
                    id: uuidv4(),
                    term: "",
                    changeByAmount: "0.00",
                    additionalFee: "0.00",
                  },
                ]
          );
          setDLT(
            filteredTenant?.leaseSettings?.pdfFormTemplates
              ?.defaultLeaseTemplates?.length >= 1
              ? filteredTenant?.leaseSettings?.pdfFormTemplates
                  ?.defaultLeaseTemplates
              : [
                  {
                    id: uuidv4(),
                    template: "",
                  },
                ]
          );
          setDRT(
            filteredTenant?.leaseSettings?.pdfFormTemplates
              ?.defaultRenewalTemplates?.length >= 1
              ? filteredTenant?.leaseSettings?.pdfFormTemplates
                  ?.defaultRenewalTemplates
              : [
                  {
                    id: uuidv4(),
                    template: "",
                  },
                ]
          );
          setDMRT(
            filteredTenant?.leaseSettings?.pdfFormTemplates
              ?.defaultRenewalMTMTemplates?.length >= 1
              ? filteredTenant?.leaseSettings?.pdfFormTemplates
                  ?.defaultRenewalMTMTemplates
              : [
                  {
                    id: uuidv4(),
                    template: "",
                  },
                ]
          );
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchTenants();
    }
  }, [companyName, isEditActive]);

  const handleChange = (value, name, id) => {
    const updatedAccounts = accounts.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setAccounts(updatedAccounts);
  };

  const addAccount = () => {
    const newAccount = {
      id: uuidv4(),
      term: "",
      changeByAmount: "0.00",
      additionalFee: "0.00",
    };
    setAccounts([...accounts, newAccount]);
  };

  const removeAccount = (id) => {
    const updatedAccounts = accounts.filter((item) => item.id !== id);
    setAccounts(updatedAccounts);
  };

  return (
    <div>
      <Card
        title="Lease Settings"
        extra={
          !isEditActive ? (
            <Button
              type="link"
              onClick={() => {
                setIsEditActive(true);
                isUpdate(true);
              }}
            >
              Edit
            </Button>
          ) : (
            ""
          )
        }
      >
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          form={form}
          autoComplete="off"
          colon={false}
          initialValues={initialValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Default Lease Generation Method"
            name="leaseGenerationDefaultMethod"
          >
            {isEditActive ? (
              <Radio.Group onChange={handleTemplate}>
                <Space direction="vertical">
                  <Radio value="SayEagle Lease Templates">
                    SayEagle Lease Templates
                  </Radio>
                  <Radio value="PDF Form Templates">PDF Form Templates</Radio>
                </Space>
              </Radio.Group>
            ) : (
              <p>
                {data?.leaseGenerationDefaultMethod
                  ? data?.leaseGenerationDefaultMethod
                  : ""}
              </p>
            )}
          </Form.Item>

          <h4>Default New Lease Templates</h4>
          {template === "SayEagle Lease Templates" ? (
            <>
              <Form.Item label="Lease Template" name="leaseTemplateL">
                {isEditActive ? (
                  <Select
                    showSearch
                    placeholder="Choose Template..."
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      {
                        value: "New Move in Lease Template",
                      },
                      {
                        value: "New Move in Lease Template Copy (TEST)",
                      },
                      {
                        value: "Renewal Lease Template",
                      },
                    ]}
                  />
                ) : (
                  <p>
                    {data?.sayEagleTemplates?.defaultLeaseTemplates
                      ?.leaseTemplate === ""
                      ? "--"
                      : data?.sayEagleTemplates?.defaultLeaseTemplates
                          ?.leaseTemplate}
                  </p>
                )}
              </Form.Item>
              <Form.Item label="Addenda Templates" name="addendaTemplatesL">
                {isEditActive ? (
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Click to add addenda"
                    options={[
                      { value: "2209 1/2 NE 16 Terr." },
                      { value: "6119 NW 48th" },
                      { value: "6119 NW 48th Driveway note" },
                      { value: "6119 NW 48th Security deposit" },
                      { value: "6119 NW 48th smoking" },
                    ]}
                  />
                ) : (
                  <ul style={{ display: "flex" }}>
                    {data?.sayEagleTemplates?.defaultLeaseTemplates
                      ?.addendaTemplates.length > 0
                      ? data?.sayEagleTemplates?.defaultLeaseTemplates?.addendaTemplates.map(
                          (item, index) => (
                            <li key={index}>
                              {item}
                              {index !==
                                data?.sayEagleTemplates?.defaultLeaseTemplates
                                  ?.addendaTemplates.length -
                                  1 && <span>,&nbsp;</span>}
                            </li>
                          )
                        )
                      : "--"}
                  </ul>
                )}
              </Form.Item>
              <Form.Item label="Lease Attachments" name="leaseAttachmentsL">
                {isEditActive ? (
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Click to add addenda"
                    options={[
                      { value: "fw9__1_.pdf" },
                      {
                        value:
                          "Landlord_Tenant_Info_Pamphlet__11-2014___1_.pdf",
                      },
                    ]}
                  />
                ) : (
                  <ul style={{ display: "flex" }}>
                    {data?.sayEagleTemplates?.defaultLeaseTemplates
                      ?.leaseAttachments.length > 0
                      ? data?.sayEagleTemplates?.defaultLeaseTemplates?.leaseAttachments.map(
                          (item, index) => (
                            <li key={index}>
                              {item}
                              {index !==
                                data?.sayEagleTemplates?.defaultLeaseTemplates
                                  ?.leaseAttachments.length -
                                  1 && <span>,&nbsp;</span>}
                            </li>
                          )
                        )
                      : "--"}
                  </ul>
                )}
              </Form.Item>
            </>
          ) : isEditActive ? (
            <Form.Item label="Lease Template(s)">
              <Templates templates={dLT} setTemplates={setDLT} />
            </Form.Item>
          ) : (
            <Form.Item label="Lease Template">
              {data?.pdfFormTemplates?.defaultLeaseTemplates.map(
                (value, index) => (
                  <React.Fragment key={index}>
                    <span>
                      {value.template}{" "}
                      {index ===
                      data?.pdfFormTemplates?.defaultLeaseTemplates.length - 1
                        ? ""
                        : ", "}
                    </span>
                  </React.Fragment>
                )
              )}
            </Form.Item>
          )}
          <Divider />
          <h4>Default Renewal Templates</h4>
          {template === "SayEagle Lease Templates" ? (
            <>
              <Form.Item label="Lease Template" name="renewalLeaseTemplateR">
                {isEditActive ? (
                  <Select
                    showSearch
                    placeholder="Choose Template..."
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      {
                        value: "New Move in Lease Template",
                      },
                      {
                        value: "New Move in Lease Template Copy (TEST)",
                      },
                      {
                        value: "Renewal Lease Template",
                      },
                    ]}
                  />
                ) : (
                  <p>
                    {data?.sayEagleTemplates?.defaultRenewalTemplates
                      ?.renewalTemplate === ""
                      ? "--"
                      : data?.sayEagleTemplates?.defaultRenewalTemplates
                          ?.renewalTemplate}
                  </p>
                )}
              </Form.Item>
              <Form.Item
                label="Addenda Templates"
                name="renewalAddendaTemplateR"
              >
                {isEditActive ? (
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Click to add addenda"
                    options={[
                      { value: "2209 1/2 NE 16 Terr." },
                      { value: "6119 NW 48th" },
                      { value: "6119 NW 48th Driveway note" },
                      { value: "6119 NW 48th Security deposit" },
                      { value: "6119 NW 48th smoking" },
                    ]}
                  />
                ) : (
                  <ul style={{ display: "flex" }}>
                    {data?.sayEagleTemplates?.defaultRenewalTemplates?.addendaTemplates.length > 0
                      ? data?.sayEagleTemplates?.defaultRenewalTemplates?.addendaTemplates.map(
                          (item, index) => (
                            <li key={index}>
                              {item}
                              {index !==
                                data?.sayEagleTemplates?.defaultRenewalTemplates
                                  ?.addendaTemplates.length -
                                  1 && <span>,&nbsp;</span>}
                            </li>
                          )
                        )
                      : "--"}
                  </ul>
                )}
              </Form.Item>
              <Form.Item
                label="Lease Attachments"
                name="renewalLeaseAttachmentR"
              >
                {isEditActive ? (
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Click to add addenda"
                    options={[
                      { value: "fw9__1_.pdf" },
                      {
                        value:
                          "Landlord_Tenant_Info_Pamphlet__11-2014___1_.pdf",
                      },
                    ]}
                  />
                ) : (
                  <ul style={{ display: "flex" }}>
                    {data?.sayEagleTemplates?.defaultRenewalTemplates
                      ?.renewalAttachments.length > 0
                      ? data?.sayEagleTemplates?.defaultRenewalTemplates?.renewalAttachments.map(
                          (item, index) => (
                            <li key={index}>
                              {item}
                              {index !==
                                data?.sayEagleTemplates?.defaultRenewalTemplates
                                  ?.renewalAttachments.length -
                                  1 && <span>,&nbsp;</span>}
                            </li>
                          )
                        )
                      : "--"}
                  </ul>
                )}
              </Form.Item>
            </>
          ) : isEditActive ? (
            <Form.Item label="Lease Template(s)">
              <Templates templates={dRT} setTemplates={setDRT} />
            </Form.Item>
          ) : (
            <Form.Item label="Lease Templates">
              {data?.pdfFormTemplates?.defaultRenewalTemplates.map(
                (value, index) => (
                  <React.Fragment key={index}>
                    <span>
                      {value.template}{" "}
                      {index ===
                      data?.pdfFormTemplates?.defaultRenewalTemplates.length - 1
                        ? ""
                        : ", "}
                    </span>
                  </React.Fragment>
                )
              )}
            </Form.Item>
          )}
          <Divider />
          <h4>Default Renewal Month to Month Templates</h4>
          {template === "SayEagle Lease Templates" ? (
            <>
              <Form.Item
                label="Lease Template"
                name="monthToMonthLeaseTemplateRM"
              >
                {isEditActive ? (
                  <Select
                    showSearch
                    placeholder="Choose Template..."
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      {
                        value: "New Move in Lease Template",
                      },
                      {
                        value: "New Move in Lease Template Copy (TEST)",
                      },
                      {
                        value: "Renewal Lease Template",
                      },
                    ]}
                  />
                ) : (
                  <p>
                    {data?.sayEagleTemplates?.defaultRenewalMTMTemplates
                      ?.mTMRenewalTemplate === ""
                      ? "--"
                      : data?.sayEagleTemplates?.defaultRenewalMTMTemplates
                          ?.mTMRenewalTemplate}
                  </p>
                )}
              </Form.Item>
              <Form.Item
                label="Addenda Templates"
                name="monthToMonthAddendaTemplateRM"
              >
                {isEditActive ? (
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Click to add addenda"
                    options={[
                      { value: "2209 1/2 NE 16 Terr." },
                      { value: "6119 NW 48th" },
                      { value: "6119 NW 48th Driveway note" },
                      { value: "6119 NW 48th Security deposit" },
                      { value: "6119 NW 48th smoking" },
                    ]}
                  />
                ) : (
                  <ul style={{ display: "flex" }}>
                    {data?.sayEagleTemplates?.defaultRenewalMTMTemplates
                      ?.addendaTemplates.length > 1
                      ? data?.sayEagleTemplates?.defaultRenewalMTMTemplates?.addendaTemplates.map(
                          (item, index) => (
                            <li key={index}>
                              {item}
                              {index !==
                                data?.sayEagleTemplates
                                  ?.defaultRenewalMTMTemplates?.addendaTemplates
                                  .length -
                                  1 && <span>,&nbsp;</span>}
                            </li>
                          )
                        )
                      : "--"}
                  </ul>
                )}
              </Form.Item>
              <Form.Item
                label="Lease Attachments"
                name="monthToMonthLeaseAttachmentRM"
              >
                {isEditActive ? (
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Click to add addenda"
                    options={[
                      { value: "fw9__1_.pdf" },
                      {
                        value:
                          "Landlord_Tenant_Info_Pamphlet__11-2014___1_.pdf",
                      },
                    ]}
                  />
                ) : (
                  <ul style={{ display: "flex" }}>
                    {data?.sayEagleTemplates?.defaultRenewalMTMTemplates
                      ?.mTmRenewalAttachments.length > 1
                      ? data?.sayEagleTemplates?.defaultRenewalMTMTemplates?.mTmRenewalAttachments.map(
                          (item, index) => (
                            <li key={index}>
                              {item}
                              {index !==
                                data?.sayEagleTemplates
                                  ?.defaultRenewalMTMTemplates
                                  ?.mTmRenewalAttachments.length -
                                  1 && <span>,&nbsp;</span>}
                            </li>
                          )
                        )
                      : "--"}
                  </ul>
                )}
              </Form.Item>
            </>
          ) : isEditActive ? (
            <Form.Item label="Lease Template(s)">
              <Templates templates={dMRT} setTemplates={setDMRT} />
            </Form.Item>
          ) : (
            <Form.Item label="Lease Templates">
              {data?.pdfFormTemplates?.defaultRenewalMTMTemplates.map(
                (value, index) => (
                  <React.Fragment key={index}>
                    <span>
                      {value.template}{" "}
                      {index ===
                      data?.pdfFormTemplates?.defaultRenewalMTMTemplates
                        .length -
                        1
                        ? ""
                        : ", "}{" "}
                    </span>
                  </React.Fragment>
                )
              )}
            </Form.Item>
          )}
          <Divider />
          <h4>Default Renewal Settings</h4>
          <Form.Item label="Letter Template" name="template">
            {isEditActive ? (
              <Select
                showSearch
                placeholder="Choose Template..."
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "Renewal Notice Letter",
                  },
                ]}
                style={{ width: "35%" }}
              />
            ) : (
              <p>
                {data?.defaultRenewalSettings?.template === ""
                  ? "--"
                  : data?.defaultRenewalSettings?.template}
              </p>
            )}
          </Form.Item>
          {isEditActive && (
            <Form.Item label="Change rent by" name="changeRentBy">
              <Radio.Group onChange={handleDollarOrPerc}>
                <Space direction="vertical">
                  <Radio value="dollar">Dollar Amount</Radio>
                  <Radio value="percentage">Percentage</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          )}
          <Form.Item label="Renewal Options">
            {isEditActive ? (
              <ul>
                <Row style={{ marginBottom: 12 }}>
                  <Col className="tableHead" span={9}>
                    <p>Term</p>
                  </Col>
                  <Col className="tableHead" span={9}>
                    <p>Change by {amount === "dollar" ? "$" : "%"}</p>
                  </Col>
                  <Col className="tableHead" span={5}>
                    <p>Additional Fee</p>
                  </Col>
                  <Col span={1}></Col>
                </Row>
                {accounts.map((item) => (
                  <li key={item.id}>
                    <Form.Item label="">
                      <Row gutter={16}>
                        <Col span={9}>
                          <Form.Item label="">
                            <Select
                              showSearch
                              style={{ width: "100%" }}
                              options={[
                                { value: "Month to Month" },
                                { value: "3 Month" },
                                { value: "6 Month" },
                                { value: "9 Month" },
                                { value: "12 Month" },
                                { value: "15 Month" },
                                { value: "18 Month" },
                                { value: "21 Month" },
                                { value: "24 Month" },
                              ]}
                              value={item.term}
                              onChange={(value) =>
                                handleChange(value, "term", item.id)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={9}>
                          <Form.Item label="">
                            <Input
                              type="Number"
                              prefix={amount === "dollar" ? "$" : "%"}
                              value={item.changeByAmount}
                              onChange={(e) =>
                                handleChange(
                                  e.target.value,
                                  "changeByAmount",
                                  item.id
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={5}>
                          <Form.Item label="">
                            <Input
                              type="Number"
                              value={item.additionalFee}
                              onChange={(e) =>
                                handleChange(
                                  e.target.value,
                                  "additionalFee",
                                  item.id
                                )
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col span={1}>
                          {accounts.length > 1 ? (
                            <Button
                              className="roundSmallButton"
                              onClick={() => {
                                removeAccount(item.id);
                              }}
                              type="primary"
                              shape="circle"
                              icon={
                                <i className="fa-sharp fa-solid fa-xmark"></i>
                              }
                              size={"small"}
                            />
                          ) : (
                            <></>
                          )}
                        </Col>
                      </Row>
                    </Form.Item>
                  </li>
                ))}
                <Form.Item label="">
                  <Button
                    className="addPropertyGroupButton"
                    type="primary"
                    onClick={addAccount}
                    size={"small"}
                    icon={<i className="fa-solid fa-circle-plus"></i>}
                    style={{ width: "100%" }}
                  >
                    Add Another Term
                  </Button>
                </Form.Item>
              </ul>
            ) : (
              <Table
                columns={columns}
                dataSource={accounts}
                size="small"
                pagination={false}
                rowKey={(obj) => obj.key}
              />
            )}
          </Form.Item>
          {isEditActive && (
            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isWaiting}>
                  {isWaiting ? "Please wait..." : "Save"}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setIsEditActive(false);
                    isUpdate(true);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default LeaseSetting;
